import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';

@Injectable({
  providedIn: 'root'
})
export class DivisionService {

    createDivision = gql`
    mutation sch00ldevision($blockname:String,$circlename:String,$newudisecode:String,$oldudisecode:String){
     sch00ldevision(blockName:$blockname,circleName:$circlename,newUdiseCode:$newudisecode,oldUdiseCode:$oldudisecode){
   addschooldivisionField{
     id
     oldUdiseCode
     newUdiseCode
     blockName
     circleName
     }
       mesg
     }
   }`;

   getDivision = gql`
   query{
    divisionallview{
      id
      blockName
      circleName
      oldUdiseCode
      newUdiseCode

    }
  }
   `;
  constructor(private http: HttpClient, private apollo:Apollo) { }

  getProducts() {
    return this.http.get<any>('assets/showcase/data/products.json')
        .toPromise()
        .then(res => <any>res.data)
        .then(data => { return data; });
}

    saveNewDivision(data:any){
       return this.apollo.mutate({
            mutation: this.createDivision,
            variables: data,

          })
    }

    loadDivisions(){
        return this.apollo.mutate({
            mutation: this.getDivision,


          })
    }
}
